import { ComponentProps, forwardRef } from 'react'
import { webchatClasses } from '../../styles/classes'

import { Avatar } from '../Avatar'
import { X } from 'lucide-react'

export const MessagePreview = forwardRef<
  HTMLDivElement,
  ComponentProps<'div'> & { avatarUrl?: string; botName?: string; description?: string; onClose?: () => void }
>(({ children, onClick, avatarUrl, botName, description, onClose, ...props }, ref) => {
  const { messagePreview } = webchatClasses
  const { container, closeButton, message: messageClass, avatar, description: descriptionClass } = messagePreview ?? {}

  return (
    <div {...props} {...container} ref={ref} onClick={onClick}>
      <Avatar src={avatarUrl} {...avatar}>
        {botName || 'Bot'}
      </Avatar>
      <p {...messageClass}>{children}</p>
      <p {...descriptionClass}>{description}</p>
      <X
        {...closeButton}
        onClick={(e) => {
          e.stopPropagation()
          onClose?.()
        }}
      />
    </div>
  )
})

MessagePreview.displayName = 'MessagePreview'
